module.exports = __webpack_public_path__ + "static/media/selectGroup.67a31290.PNG";